<cap-functionbar></cap-functionbar>
<!-- Empty functionbar where breadcrumbs would be -->

<cap-content-header disableBreadcrumb="true">
  <cap-title>
    {{ "grundstueck.ListTitel" | translate }}
  </cap-title>
  <cap-title-functionbar>
    <div class="bsg-input-wrapper" id="filter">
      <div class="input-group">
        <input
          [(ngModel)]="filterTerm"
          class="form-control form-control-inline rounded-start border-end-0"
          id="filterInput"
          placeholder="{{ 'meineGrundstuecke.filter' | translate }}"
          type="search" />
        <div class="input-group-text bg-white border-start-0"><i class="fa fa-filter" style="color: grey"></i></div>
        <button (click)="clearFilter()" class="btn btn-white" tabindex="-1" type="button">
          <span class="fas fa-times"></span>
        </button>
      </div>
    </div>
  </cap-title-functionbar>
</cap-content-header>

@if (grundstueckEigentuemerSearchResponse) {
  @if (grundstueckEigentuemerSearchResponse.additionalAuthorizationNeeded) {
    <div>
      <p>{{ "core.navigation.meineGrundstueckePublic.identifizierungsStufeUnzureichend" | translate }}</p>
      @if (grundstueckEigentuemerSearchResponse.additionalAuthorizationURI) {
        <p>{{ "core.navigation.meineGrundstueckePublic.stepUpRegistrierung" | translate }}</p>
        <a
          [href]="grundstueckEigentuemerSearchResponse.additionalAuthorizationURI"
          class="btn btn-outline-primary btn-sm btn-actionpane"
          target="_blank">
          {{ "core.navigation.meineGrundstueckePublic.stepUpRegistrierungLinkText" | translate }}</a
        >
      }
    </div>
  } @else {
    <cap-meine-grundstuecke-icp-table [filterTerm]="filterTerm" [listLoader]="grundstueckLoader" [showZeilenSelect]="false">
    </cap-meine-grundstuecke-icp-table>
  }
} @else {
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-1 text-center">
        <cap-spinner-small></cap-spinner-small>
      </div>
    </div>
  </div>
}
